import React from 'react';
import { Search, Layers, TrendingUp } from 'lucide-react';

const HowWeWork = () => {
  const steps = [
    {
      icon: Search,
      title: 'Analiz & İçgörü',
      description: 'Veriyle başlar, kullanıcı davranışını çözeriz.',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: Layers,
      title: 'Sistem & Uygulama',
      description: 'SEO, reklam ve UX\'i tek bir büyüme sistemine dönüştürürüz.',
      color: 'from-teal-500 to-emerald-500'
    },
    {
      icon: TrendingUp,
      title: 'Ölçüm & Optimizasyon',
      description: 'Sonuç üretmeyen hiçbir şey devam etmez.',
      color: 'from-emerald-500 to-green-500'
    }
  ];

  return (
    <section className="py-20 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-3xl top-0 left-1/4 animate-pulse"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nasıl Çalışıyoruz?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-500 hover:transform hover:-translate-y-2"
              style={{
                animation: 'fade-in-up 0.8s ease-out both',
                animationDelay: `${index * 0.15}s`
              }}
            >
              {/* Icon */}
              <div className="relative w-16 h-16 mb-6">
                <div className={`absolute inset-0 bg-gradient-to-br ${step.color} rounded-xl flex items-center justify-center transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110`}>
                  <step.icon className="w-8 h-8 text-white transition-transform duration-500 group-hover:rotate-[-12deg]" />
                </div>
                <div className="absolute inset-0 bg-cyan-500/50 rounded-xl blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500"></div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">
                {step.title}
              </h3>

              <p className="text-gray-400 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
